import { SafeArea } from "@capacitor-community/safe-area";
import { useEffect } from "react";

import { isNativePlatform } from "../capacitor/appsHelpers";
import useLocalStorage from "./useLocalStorage";

const useTheme = () => {
	const [theme, setTheme] = useLocalStorage("theme", "light");

	const toggleTheme = async () => {
		setTheme((prevTheme) => (prevTheme === "light" ? "dark" : "light"));
	};

	useEffect(() => {
		if (isNativePlatform()) {
			SafeArea.setSystemBarsStyle({
				style: theme === "light" ? "light" : "dark",
			}).catch(() => {
				// do nothing
			});
		}
		document.documentElement.setAttribute("data-theme", theme);
	}, [theme]);

	return {
		theme,
		toggleTheme,
	};
};

export default useTheme;
